import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import FeaturedPropertyThumbnail from "./FeaturedPropertyThumbnail";
import LoadingMessage from "../LoadingMessage";
import { startGetFeaturedProperty } from "../../actions/properties";
import ErrorMessage from "../ErrorMessage";

function FeaturedProperty(props) {
  const dispatch = useDispatch();
  const isLoading = useSelector(
    (state) => state.property.featuredProperty.loading
  );
  const loadedProperties = useSelector(
    (state) => state.property.featuredProperty.data
  );
  const errorDesc = useSelector(
    (state) => state.property.featuredProperty.error
  );

  useEffect(() => {
    dispatch(startGetFeaturedProperty());
  }, []);

  if (isLoading) {
    return <LoadingMessage></LoadingMessage>;
  } else if (
    loadedProperties !== undefined &&
    loadedProperties != null &&
    loadedProperties.length >= 0
  ) {
    return (
      <>
        {loadedProperties.map((property) => (
          <FeaturedPropertyThumbnail
            key={property.id}
            data={property}
            featuredProperty={true}
          />
        ))}
      </>
    );
  } else {
    return (
      <>
        <ErrorMessage message={errorDesc} />
      </>
    );
  }
}

export default FeaturedProperty;
